<template>
  <!-- Order Details Tabs -->
  <section id="order-tabs" class="section my-5">
    <pdl-tabs v-if="isTranslationLoaded" :model-value="tabSelected" @update:modelValue="onTabClick">
      <pdl-tab-pane
        v-for="(productTypeData, productType) in filteredCartProductsCombined"
        :key="productType"
        :name="productType"
      >
        <template #label>
          <h3 class="heading heading--md m-0">
            {{ tabName(productType) }}
          </h3>
        </template>

        <template v-if="!cartIsEmpty">
          <cart-products-list
            :part-type-key="productType"
            item-id-key="baseProduct"
            :list-data="productTypeData"
            :cart-summary="cartSummary"
          >
          </cart-products-list>
        </template>

        <template v-else>
          <div v-if="productType === 'bikes'">{{ $t('myCart.B2B.countInCart.bikes', ['(0)']) }}</div>
          <div v-else-if="productType === 'parts'">{{ $t('myCart.B2B.countInCart.partsAccessories', ['(0)']) }}</div>
          <div v-else-if="productType === 'customWaterBottles'">{{ $t('checkout.custom.inCart', ['(0)']) }}</div>
          <div v-else-if="productType === 'projectOneBikes'">{{ $t('myCart.B2B.countInCart.bikes', ['(0)']) }}</div>
        </template>
      </pdl-tab-pane>
    </pdl-tabs>
  </section>
</template>
<script>
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import CartProductsList from '@/components/cart/CartProductsList.vue';
import {PdlTabs, PdlTabPane} from '@pedal/pdl-tabs';
import {useIsTranslationLoaded} from '@/composables/is-translation-loaded.js';

export default {
  components: {
    CartProductsList,
    PdlTabs,
    PdlTabPane,
  },
  props: {
    bikes: {
      type: Array,
      default: () => [],
    },
    parts: {
      type: Array,
      default: () => [],
    },
    customWaterBottles: {
      type: Array,
      default: () => [],
    },
    projectOneBikes: {
      type: Array,
      default: () => [],
    },
    cartSummary: {
      type: Object,
      default: () => null,
    },
    tabSelected: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      dialogVisible: false,
      itemToDeleteElement: null,
      itemDeleted: false,
      isTranslationLoaded: false,
    };
  },

  computed: {
    bikesAreAvailable() {
      return this.bikes && this.bikes.length;
    },

    partsAreAvailable() {
      return this.parts && this.parts.length;
    },

    customWaterBottlesAreAvailable() {
      return this.customWaterBottles && this.customWaterBottles.length;
    },

    projectOneBikesAreAvailable() {
      return this.projectOneBikes && this.projectOneBikes.length;
    },

    cartIsEmpty() {
      return (
        isEmpty(this.parts) && isEmpty(this.bikes) && isEmpty(this.customWaterBottles) && isEmpty(this.projectOneBikes)
      );
    },

    currentCartProductsCombined() {
      return {
        bikes: this.bikes,
        parts: this.parts,
        customWaterBottles: this.customWaterBottles,
        projectOneBikes: this.projectOneBikes,
      };
    },

    filteredCartProductsCombined() {
      let filtered = {};
      Object.keys(this.currentCartProductsCombined).forEach((productType) => {
        if (this.cartSummary[productType].totalItems > 0)
          filtered[productType] = this.currentCartProductsCombined[productType];
      });
      return Object.keys(filtered).length ? filtered : this.currentCartProductsCombined;
    },
  },

  created() {
    useIsTranslationLoaded(() => {
      this.isTranslationLoaded = true;
    });
  },

  methods: {
    onTabClick(paneName) {
      this.$emit('tab-selected', paneName);
    },

    getGroupDisplayColor(product) {
      let colorCode = get(product, 'entries[0].variantValueCategories[0].Color.code');
      return colorCode ? 'swatch-' + colorCode : null;
    },

    getGroupDisplayColorName(product) {
      return get(product, 'entries[0].variantValueCategories[0].Color.name');
    },

    getCollapseItemName(prefix, index) {
      return prefix + '-' + index;
    },

    tabName(key) {
      switch (key) {
        case 'bikes':
          return this.$t('text.bikes');
        case 'parts':
          return this.$t('text.accessories');
        case 'customWaterBottles':
          return this.$t('checkout.custom');
        case 'projectOneBikes':
          return this.$t('checkout.projectOne');
      }
    },
  },
};
</script>
